(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pipkin-golden-wonder"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-wonder-compass-form]');
    if (!form) return;
    event.preventDefault();
    const section = form.closest('[data-wonder-compass]');
    const status = section.querySelector('[data-compass-status]');
    const results = section.querySelector('[data-compass-results]');
    const worldLink = section.querySelector('[data-compass-world]');
    const ageLink = section.querySelector('[data-compass-age-link]');
    const submit = form.querySelector('[type="submit"]');
    const ageOption = form.elements.age.selectedOptions[0];
    const playOption = form.elements.play.selectedOptions[0];
    const budget = Number(form.elements.budget.value) || null;
    const worldName = playOption.dataset.world || '';
    const keywords = (playOption.dataset.keywords || '').split('|').filter(Boolean);
    const matchesPlayStyle = (text) => keywords.some((keyword) =>
      new RegExp('(^|[^a-z0-9])' + keyword + '($|[^a-z0-9])', 'i').test(text)
    );
    const appendWorldSuggestion = () => {
      if (results.querySelector('.gw-compass-world-note')) return;
      const note = document.createElement('p');
      note.className = 'gw-compass-world-note';
      note.textContent = section.dataset.worldSuggestion + ' ' + worldName;
      results.append(note);
    };
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const ageUrl = new URL(root + 'collections/' + encodeURIComponent(ageOption.value), window.location.origin);
    ageUrl.searchParams.set('sort_by', 'price-ascending');
    ageLink.href = ageUrl.href;
    worldLink.href = new URL(playOption.dataset.worldUrl, window.location.origin).href;
    worldLink.textContent = section.dataset.worldCta + ' ' + worldName;
    worldLink.setAttribute('aria-label', section.dataset.worldCta + ' ' + worldName);
    results.replaceChildren();
    worldLink.hidden = true;
    ageLink.hidden = true;
    status.textContent = section.dataset.loading;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');

    try {
      const requestUrl = new URL(ageUrl.href);
      requestUrl.searchParams.set('section_id', 'main');
      const response = await fetch(requestUrl.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Collection section request failed');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = Array.from(parsed.querySelectorAll('li[data-product-id]')).map((card) => {
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return null;
        const image = card.querySelector('img');
        const titleNode = card.querySelector('h3, h2, [class*="product-title"]');
        const priceNode = card.querySelector('[class*="price"]');
        const title = (titleNode ? titleNode.textContent : link.textContent || '').replace(/\s+/g, ' ').trim();
        const priceText = (priceNode ? priceNode.textContent : card.textContent || '').replace(/\s+/g, ' ').trim();
        const amounts = Array.from(priceText.matchAll(/\$\s*([\d,]+(?:\.\d{1,2})?)/g)).map((match) => Number(match[1].replace(/,/g, ''))).filter(Number.isFinite);
        const href = new URL(link.getAttribute('href'), window.location.origin);
        if (href.origin !== window.location.origin) return null;
        return {
          title,
          href: href.href,
          image: image ? (image.getAttribute('src') || image.getAttribute('data-src') || '') : '',
          alt: image ? image.getAttribute('alt') || title : title,
          priceText,
          price: amounts.length ? Math.min.apply(null, amounts) : null,
          searchText: (card.textContent || '').toLowerCase()
        };
      }).filter((product) => product && product.title && !/sold out/i.test(product.searchText));
      const withinBudget = cards.filter((product) => budget === null || (product.price !== null && product.price <= budget));
      const exactMatches = withinBudget.filter((product) => matchesPlayStyle(product.searchText));
      if (exactMatches.length < 3) throw new Error('Load more age and play matches');
      const chosen = exactMatches.slice(0, 3);

      if (!chosen.length) {
        throw new Error('No inline age suggestions were returned');
      }

      appendWorldSuggestion();
      chosen.forEach((product) => {
        const article = document.createElement('article');
        article.className = 'gw-compass-product';
        const anchor = document.createElement('a');
        anchor.href = product.href;
        const image = document.createElement('img');
        if (product.image) image.src = new URL(product.image, window.location.origin).href;
        image.alt = product.alt;
        image.loading = 'lazy';
        image.decoding = 'async';
        const copy = document.createElement('div');
        copy.className = 'gw-compass-product-copy';
        const title = document.createElement('h3');
        title.textContent = product.title;
        const price = document.createElement('p');
        price.className = 'gw-compass-product-price';
        price.textContent = product.priceText;
        anchor.append(image, copy);
        copy.append(title, price);
        article.append(anchor);
        results.append(article);
      });

      status.textContent = exactMatches.length
        ? (chosen.length === 1 ? section.dataset.resultsOne : section.dataset.resultsMany)
        : section.dataset.noStyleMatch + ' ' + worldName + '.';
      worldLink.hidden = true;
    } catch (error) {
      try {
        const fallbackUrl = new URL(root + 'collections/' + encodeURIComponent(ageOption.value) + '/products.json', window.location.origin);
        fallbackUrl.searchParams.set('limit', '200');
        const fallbackResponse = await fetch(fallbackUrl.href, { headers: { Accept: 'application/json' } });
        if (!fallbackResponse.ok) throw new Error('Age collection products could not be loaded');
        const fallbackData = await fallbackResponse.json();
        const fallbackProducts = (fallbackData.products || []).map((product) => {
          const variants = (product.variants || []).filter((variant) => variant.available && (budget === null || Number(variant.price) <= budget));
          const price = variants.length ? Math.min.apply(null, variants.map((variant) => Number(variant.price)).filter(Number.isFinite)) : null;
          const tags = Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || '');
          const searchText = [product.title, product.product_type, tags, product.body_html].join(' ').replace(/<[^>]*>/g, ' ').toLowerCase();
          const rawImage = (product.images && product.images[0]) || product.image || '';
          const image = typeof rawImage === 'string' ? rawImage : (rawImage && (rawImage.src || rawImage.url)) || '';
          return { product, variants, price, searchText, image };
        }).filter((item) => item.variants.length && item.price !== null);
        const ageMatches = fallbackProducts.filter((item) => matchesPlayStyle(item.searchText));
        const fallbackChosen = (ageMatches.length ? ageMatches : fallbackProducts).slice(0, 3);
        if (!fallbackChosen.length) {
          appendWorldSuggestion();
          status.textContent = section.dataset.empty;
          return;
        }
        appendWorldSuggestion();
        fallbackChosen.forEach((item) => {
          const article = document.createElement('article');
          article.className = 'gw-compass-product';
          const anchor = document.createElement('a');
          anchor.href = new URL(root + 'products/' + encodeURIComponent(item.product.handle), window.location.origin).href;
          const image = document.createElement('img');
          if (item.image) image.src = new URL(item.image, window.location.origin).href;
          image.alt = item.product.title;
          image.loading = 'lazy';
          image.decoding = 'async';
          const copy = document.createElement('div');
          copy.className = 'gw-compass-product-copy';
          const title = document.createElement('h3');
          title.textContent = item.product.title;
          const price = document.createElement('p');
          price.className = 'gw-compass-product-price';
          price.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.price);
          anchor.append(image, copy);
          copy.append(title, price);
          article.append(anchor);
          results.append(article);
        });
        status.textContent = fallbackChosen.length === 1 ? section.dataset.resultsOne : section.dataset.resultsMany;
      } catch (fallbackError) {
        appendWorldSuggestion();
        status.textContent = section.dataset.error;
      }
      ageLink.hidden = true;
      worldLink.hidden = true;
    } finally {
      submit.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
